<div class="mb-4">

  <div class="form-group" [ngStyle]="{'width': width }"
    [ngClass]="{'has-error' : control ? !control.valid: true, 'align-items-center' : verticallyAlign }">
    <label *ngIf="label && !ignoreLabel" [attr.for]="idName" class="mb-0" [ngStyle]="{'opacity': labelOpacity}">
      {{ label }}<span *ngIf="isRequiredField()" class="text-danger">*</span>
    </label>
    <ng-content></ng-content>
  </div>
  <div class="row validation mx-0" [ngStyle]="{'width': width }" style="margin-top: -16px; white-space: nowrap;">
    <div class="col-12 col-md-7 p-0">
      <div class="text-danger mb-2 marg" *ngIf="control?.errors?.required && (control?.touched || externalTrigger)"
        [ngStyle]="{'margin-left': label && !ignoreLabel ? '140px' : '0' }">
        {{labelName}} is required.
      </div>
      <div class="text-danger mb-2 marg"
        *ngIf="control?.errors?.canDefaultValidator && (control?.touched || externalTrigger)"
        [ngStyle]="{'margin-left': label && !ignoreLabel ? '140px' : '0' }">
        {{labelName}} failed, default already exists
      </div>
      <div class="text-danger mb-2 marg"
        *ngIf="control?.errors?.canDefaultBillToValidator && (control?.touched || externalTrigger)"
        [ngStyle]="{'margin-left': label && !ignoreLabel ? '140px' : '0' }">
        {{labelName}} failed, default already exists
      </div>
      <div class="text-danger mb-2 marg"
        *ngIf="control?.errors?.canDefaultShipToValidator && (control?.touched || externalTrigger)"
        [ngStyle]="{'margin-left': label && !ignoreLabel ? '140px' : '0' }">
        {{labelName}} failed, default already exists
      </div>
      <div class="text-danger mb-2 marg" *ngIf="control?.value?.length >= maxLength && (control?.dirty || externalTrigger)"
        [ngStyle]="{'margin-left': label && !ignoreLabel ? '140px' : '0' }">
        {{labelName}} has a max length of {{maxLength}}.
      </div>
    </div>
    <div class="col-12 col-md-5 p-0 text-right text-muted" >
      <div *ngIf="additionalText">
        <div>{{additionalText}}</div>
      </div>
      <div *ngIf="maxLength && maxLength != defaultMaxLength">
        <div>{{control.value ? control.value.length : 0}}/{{maxLength}}<span *ngIf="!shortLengthCount"> characters</span></div>
      </div>
    </div>
  </div>
</div>
